//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    VIDFLEET_CONFIGURATION_HUBSPOT_LOAD,
    VIDFLEET_CONFIGURATION_HUBSPOT_SAVE
} from 'Redux/actionTypes';

//```import global actions
import {
    vidfleetConfigurationHubSpotLoadDataResult,
    vidfleetConfigurationHubSpotSaveResult,
} from 'Redux/actions';

/**
 * Method for get customer data for Server
 * @param {object} payload Payload with info
 */
function* vidFleetConfigurationHubSpotLoad({ payload }) {
    try {

        let result = {}
        let { esn, devices, mode } = payload;

        let QUERY_NAT_CONFIG = `
            query getNatConfiguration($esn: String) {
                result: getNatConfiguration(esn: $esn)
            }
        `
        let natConfiguration = yield call(
            clientQuery,
            QUERY_NAT_CONFIG,
            {},
            endpoints.GRAPHQL_GENERAL,
        );

        if (natConfiguration?.result) {
            try {
                let resultNatConfiguration = JSON.parse(natConfiguration?.result)
                result.fleetConfig = resultNatConfiguration;
            } catch (error) { }
        }

        if (mode === "Single") {
            if (esn) {

                let QUERY_NAT_CONFIG_ESN = `
                    query getNatConfiguration($esn: String) {
                        result: getNatConfiguration(esn: $esn)
                    }
                `
                let natConfigurationEsn = yield call(
                    clientQuery,
                    QUERY_NAT_CONFIG_ESN,
                    {
                        esn: esn
                    },
                    endpoints.GRAPHQL_GENERAL,
                );

                if (natConfigurationEsn?.result) {
                    try {
                        let resultNatConfigurationEsn = JSON.parse(natConfigurationEsn?.result)
                        result.deviceConfig = resultNatConfigurationEsn;
                    } catch (error) { }
                }
            }
        } else {
            result.devices = devices;
        }
        result.mode = mode;
        yield put(vidfleetConfigurationHubSpotLoadDataResult(result))
    } catch (exc) {

        //```call action for return
        yield put(vidfleetConfigurationHubSpotLoadDataResult({ error: exc }));



        //```catch error
        ExceptionManager(exc,
            "Modules/vidfleet/.components/configurationHubSpot/redux/saga/",
            "vidFleetConfigurationHubSpotLoad")
    }
}


function* vidfleetConfigurationHubSpotSave({ payload }) {

    try {

        const headers = {
            'Content-Type': 'application/json'
        };
        let { config, esns, deviceIds, oldConfig, applyScopes, verificationCode } = payload;

        let data = null;

        let QUERY = `
         mutation updateVidFleetNat ($enable: Boolean!, $cycleBeginDay: Int!, $maxMonthlyUsageInMB: Int!, $scopes: [enumVidFleetScope]!, $unitIds: [Int]!, $verificationCode: String) {
           result: updateVidFleetNat (enable: $enable, cycleBeginDay: $cycleBeginDay, maxMonthlyUsageInMB: $maxMonthlyUsageInMB, scopes: $scopes, unitIds: $unitIds, verificationCode: $verificationCode)
        }
        `;

        data = yield call(
            clientMutation,
            QUERY,
            {
                enable: config.natSettings.enable,
                cycleBeginDay: config.natSettings.cycleBeginDay,
                maxMonthlyUsageInMB: config.natSettings.maxMonthlyUsageInMB,
                scopes: applyScopes,
                unitIds: deviceIds,
                verificationCode: verificationCode
            },
            endpoints.GRAPHQL_GENERAL,
        );

        yield put(vidfleetConfigurationHubSpotSaveResult(data));
    } catch (exc) {

        yield put(vidfleetConfigurationHubSpotSaveResult({ error: exc }));


        ExceptionManager(
            exc,
            "Modules/vidfleet/.components/configurationHubSpot/redux/saga/",
            "vidfleetConfigurationHubSpotSave"
        );

    }
}

function* watchMethods() {
    yield takeEvery(VIDFLEET_CONFIGURATION_HUBSPOT_LOAD, vidFleetConfigurationHubSpotLoad);
    yield takeEvery(VIDFLEET_CONFIGURATION_HUBSPOT_SAVE, vidfleetConfigurationHubSpotSave);
}

/**
 * Export for global saga
 */
export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}